import React from "react";
import "../../../css/RecruitmentScreen/CollapsibleSection.css";

const CollapsibleSection = ({
  title,
  isCollapsed,
  onToggle,
  children,
  showRequiredAsterisk = true,
}) => {
  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <div className="section-form collapsible-section">
      <div
        className={`collapsible-header ${isCollapsed ? "collapsed" : ""}`}
        onClick={handleClick}
      >
        <div className="Content">
          {title}
          {showRequiredAsterisk && (
            <span style={{ color: "var(--Error)" }}> *</span>
          )}
        </div>
        <i className={`fas fa-chevron-${isCollapsed ? "down" : "up"}`} />
      </div>
      {!isCollapsed && <div className="collapsible-content">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
